initImageZoom({
  moduleSelector: '.image-with-caption',
  wrapSelector: '.image-with-caption__image',
  innerSelector: '.image-with-caption__image-inner',
  duration: '30%',
  triggerHook: 0.8,
});
